import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';;
import { NavService } from '../../../_services/_nav.service';
import { ListaService } from '../../../_services/lista.service';
import { TipoVigencia } from '../../../_enums/enum';
import { Params } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { Message } from 'primeng/api';
import { ValidityEmployees } from '../../../_models/vigencias';
import { ListaItem } from '../../../_models/lista-item';
import { ValidityEmployeesService } from '../../../_services/vigencias-tercero.service';

@Component({
  moduleId: module.id,
  templateUrl: './validity-employees-add.component.html',
  selector: 'validity-employees-add-component'
})
export class ValidityEmployeesAddComponent {

  displayDialog = false;
  msg: Message;
  vigenciaEmployee: ValidityEmployees = new ValidityEmployees();
  listTypeValidity: ListaItem[] = [];
  loading: boolean = false;
  longitudMaximaDuracion: number = 6;
  maxDuracion: number = this.generarNueves(this.longitudMaximaDuracion);

  constructor(private listaService: ListaService,
              private router: Router,
              private route: ActivatedRoute,
              private navService: NavService,
              private validityEmployeesService: ValidityEmployeesService ) {
    this.loading = true;
    this.route.params.pipe(switchMap( ( params: Params ) => validityEmployeesService.getById( params[ 'id' ] ) ))
        .subscribe( data => {
          this.vigenciaEmployee = data;
          this.listaService.getMasterDetails( 'ListasTiposVigencias' ).subscribe( res => {
              this.listTypeValidity = res;
          } );
          this.loading = false;
        } );

  }
updateValidityEmployee() {

    if (this.shouldHideDuration()) {
      const duration = Number(this.vigenciaEmployee.duracionVigencia);
      if (!duration || duration <= 0) {
        return;
      }
    }
    if(!this.shouldHideDuration()){
      this.vigenciaEmployee.duracionVigencia = null;
    }

    this.validityEmployeesService.update(this.vigenciaEmployee).subscribe(
      () => {
        const typeMessage = 2; // 1 = Add, 2 = Update, 3 Error, 4 Custom
        this.navService.setMesage( typeMessage, this.msg );
        this.router.navigate(['/apl/vigencias'], { queryParams: { tab: 1 } });
      },
      error => {
        const typeMessage = 3; // 1 = Add, 2 = Update, 3 Error, 4 Custom
        this.navService.setMesage( typeMessage, this.msg );
      }
    );
 }

  getNombreTipoVigencia(id: any): string {
    const tipo = this.listTypeValidity.find(t => t.idLista === id);
    return tipo ? tipo.nombre : '';
  }

  shouldHideDuration(): boolean {
    const selectedId = this.vigenciaEmployee.idTipoVigencia;
    const selectedType = this.listTypeValidity.find(t => t.idLista === selectedId);
    return selectedType && (selectedType.codigo === TipoVigencia.TEMPO || selectedType.codigo === TipoVigencia.VERIFI);
  }

  limitToThreeDigits(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];
    if (allowedKeys.includes(event.key)) return;
    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
      return;
    }
    if (value.length === 0 && event.key === '0') {
      event.preventDefault();
      return;
    }
    if (value.length >= this.longitudMaximaDuracion) {
      event.preventDefault();
      return;
    }
  }

  generarNueves(n: number): number {
    return +('9'.repeat(n));
  }

  goBack(): void {
    this.router.navigate( [ '/apl/vigencias' ], { queryParams: { tab: 1 } } );
  }

}
